/**
 * Created by meirr on 9/8/16.
 */

define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');

    var FilterItemCheckBoxSelectViewController = BaseFilterItem.extend({

        LPElementsMap: {
            checkbox: ".lp_checkbox"
        },
        LPTemplatesFiles: {
            textInputItem: 'LP_filter_full_table_checkbox_item.html'
        },

        initialize: function (constructorData) {
            var textInputTemplate = require('web-agent-templates/' + this.LPTemplatesFiles.textInputItem);
            this.value = constructorData.value;
            this.onClickAdditinalEvent = constructorData.onClickAdditinalEvent;
            this.view = this.createView({
                template: textInputTemplate,
                doNotAddChild: true,
                elementType: "div",
                textInjection: {
                    value: this.value,
                    textValue: constructorData.textValue
                }
            });
        },
        events: function () {
            this.bindViewEvent({DOMEvent: "click", selector: this.LPElementsMap.checkbox, callback: this.selectItem});
        },
        render: function () {

        }
    });

    FilterItemCheckBoxSelectViewController.prototype.selectItem = function () {
        this.checked = !this.checked;
        this.toggleClass(this.getFirstElement(this.LPElementsMap.checkbox, this.view), "checked", this.checked);
        if(this.onClickAdditinalEvent) {
            this.onClickAdditinalEvent.call(this, this.checked);
        }
    };

    FilterItemCheckBoxSelectViewController.prototype.setOnClickAdditionalEvent = function (onClickAdditinalEvent) {
        this.onClickAdditinalEvent = onClickAdditinalEvent;
    };

    FilterItemCheckBoxSelectViewController.prototype.getValue = function () {
        return this.checked ? this.value : "";
    };

    FilterItemCheckBoxSelectViewController.prototype.updateFilterUI = function (filterUIData) {
        this.toggleClass(this.getFirstElement(this.LPElementsMap.checkbox, this.view), "checked", filterUIData === this.value);
        this.checked = filterUIData === this.value;
        if(this.onClickAdditinalEvent && this.checked) {
            this.onClickAdditinalEvent.call(this, this.checked);
        }
    };

    return FilterItemCheckBoxSelectViewController;
});

